import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { Formik, Form, FastField } from 'formik';
import Button from '@material-ui/core/Button';
import * as Yup from 'yup';
import { Typography, InputLabel, Paper, Box } from '@material-ui/core';
import _e from 'common/localeUtil';
import GenericDialog from './GenericDialog';
import LabelValueComponent from '../LabelValueComponent';
import FieldWrapper from '../form/FieldWrapper';
import {
	getColorHexUsingComputedStyle,
	getTitleFromSection,
	handleColorChangedForSection,
	handleSaveInEditConfigurationDialog,
} from '../../utils';
import TextInputField from '../form/TextInputField';

const useStyles = makeStyles((theme) => ({
	boxContent: {
		padding: theme.spacing(2),
		backgroundColor: theme.palette.background.paper,
		'& .height2rem': {
			height: '2rem',
		},
	},
	descriptionWrapper: {
		paddingBottom: theme.spacing(2),
	},
	eachComponent: {
		width: 300,
		marginBottom: theme.spacing(2.5),
		'& label': {
			marginBottom: theme.spacing(1),
			display: 'block',
		},
	},
	formWrapper: {
		'& .submitButton': {
			textAlign: 'right',
		},
	},
}));

const EditVideoSectionDialog = (props) => {
	const { open, handleClose, sectionId } = props;
	const classes = useStyles();
	// 	const servicesSettings = useStoreState(state => state.template.servicesSettings);
	// const setServicesSettings = useStoreActions(actions => actions.template.setServicesSettings);

	const handleSave = async (values) => {
		handleSaveInEditConfigurationDialog(values, sectionId);

		handleClose && handleClose();
	};

	const headerColorHex = getColorHexUsingComputedStyle('videos', 'header');
	// const textColorHex = getColorHexUsingComputedStyle('about', 'body');
	const title = getTitleFromSection(sectionId);

	const renderForm = () => {
		return (
			<Form className={classes.formWrapper}>
				<LabelValueComponent
					label={<InputLabel>{_e('title')}</InputLabel>}
					value={<TextInputField name="title" placeholder="" />}
				/>
				<LabelValueComponent
					label={<InputLabel>{_e('header_color')}</InputLabel>}
					value={
						<FastField
							defaultHex={headerColorHex}
							name="headerColor"
							component={FieldWrapper}
							control="colorpicker"
							callback={handleColorChangedForSection('videos', 'header')}
						/>
					}
				/>
				<Box p={1} pt={2}>
					<div className="submitButton">
						<Button
							variant="contained"
							color="primary"
							type="submit"
							// onClick={handleSave}
						>
							{_e('save')}
						</Button>
					</div>
				</Box>
			</Form>
		);
	};

	const renderContent = () => {
		return (
			<div className={`useImageBrowseWrapper`}>
				<Paper elevation={0} className={classes.boxContent}>
					<Typography variant="body1" className="bold-text" gutterBottom>
						{_e('videos')}
					</Typography>
					<Typography variant="body2">
						{_e('your_videos_desc')}
						<br />
					</Typography>
					<div className="height2rem" />
					<Formik
						initialValues={{
							// textColor: textColorHex,
							headerColor: headerColorHex,
							title,
						}}
						validationSchema={Yup.object({
							// subdomain: Yup.string()
							//   .max(15, 'Must be 15 characters or less')
							//   .required('Required')
						})}
						onSubmit={async (values, { setSubmitting }) => {
							// showFormikValues(values, setSubmitting);
							await handleSave(values);
							setSubmitting(false);
						}}
					>
						{renderForm}
					</Formik>
				</Paper>
				<Box p={1} />
			</div>
		);
	};
	return (
		<GenericDialog
			shadedContent
			maxWidth="md"
			title={_e('videos')}
			subtitle={_e('videos_desc')}
			content={renderContent()}
			showTitleDivider
			handleClose={handleClose}
			open={open}
			hideConfirmButton
		/>
	);
};

EditVideoSectionDialog.propTypes = {
	open: PropTypes.bool,
	handleClose: PropTypes.func,
	sectionId: PropTypes.string,
};

export default EditVideoSectionDialog;
